import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';
import { ITransportActiveDocumentLine } from '../../types';

class SupplierTransportDocumentActiveLineService extends BaseService<ITransportActiveDocumentLine> {
  constructor() {
    super('supplier-transport-active-document-lines');
  }

  bulkCreate = async (ddt_id: number, lines: ITransportActiveDocumentLine[]) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/bulk-create/`, {
      lines,
      ddt_id
    });
    return res;
  };
}

export const supplierTransportDocumentActiveLineService =
  new SupplierTransportDocumentActiveLineService();
